function formatStringToMask(value, pattern) {
  if (!value) return '';
  let i = 0;
  const v = value.toString();
  return pattern.replace(/#/g, () => v[i++]);
}
export default formatStringToMask;
